import BroadcastWithRtmpController from './broadcast-with-rtmp-controller';
import CaptureOrEditHighlightController from './modal-capture-highlight-recorded';
import EmbedSingleEventController from './embed-single-event-controller';
import DownloadOrExportRecordingController from './modal-download-or-export-recording';
import HighlightPreviewController from './modal-highlight-preview';
import ModalUploadEventController from './modal-upload-event';
import { AllowSocial } from '../../utils/allow-social';
import ClapprUtils from '../../utils/clappr';
import { secondsToFormattedLabel, formattedLabelToSeconds } from '../../utils/date';
import { ensureHttpOnProtocolRelativeUrl } from '../../utils/broadcast';
import { forceBrowserDownload } from '../../utils/download';
import { SanitizeRTMPURL } from '../../utils/rtmp';
import { ComputeBroadcastStatus } from '../../utils/stream-diagnostics';
import { resolutionForBroadcast } from './broadcast-with-rtmp-controller';
import { estimateProcessingTimeRemaining } from '../../utils/uploads';

const UPLOAD_PROGRESS_INTERVAL_MS = 5000;
const SIMULCAST_FPS_THRESHOLD = 10; // if we're getting at least 10 fps through, we're OK

export default class EventDetailController {
  constructor(
    $state,
    $scope,
    $sanitize,
    $timeout,
    $http,
    $location,
    AccountUploadsService,
    Broadcast,
    Channel,
    $uibModal,
    ConfirmDialog,
    Overlays,
    Facebook,
    Highlight,
    Caption,
    BandwidthTestClient,
    toaster,
    $analytics,
    $sce,
    $rootScope,
    BoxCaster,
    Recording,
    StaticRTMP
  ) {
    'ngInject';
    this.$state = $state;
    this.$http = $http;
    this.$location = $location;
    this.AccountUploadsService = AccountUploadsService;
    this.Broadcast = Broadcast;
    this.$uibModal = $uibModal;
    this.ConfirmDialog = ConfirmDialog;
    this.Highlight = Highlight;
    this.BoxCaster = BoxCaster;
    this.Recording = Recording;
    this.Caption = Caption;
    this.BandwidthTestClient = BandwidthTestClient;
    this.Overlays = Overlays;
    this.toaster = toaster;
    this.$analytics = $analytics;
    this.$sce = $sce;
    this.$sanitize = $sanitize;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.account = $rootScope.account;
    this.user = $rootScope.user;
    this.sanitizeRTMPURL = SanitizeRTMPURL;
    this.StaticRTMP = StaticRTMP;
    this.fb = Facebook;
    this.queryParams = this.$location.search();

    // XXX: this page now lives in Vue, hooray! so redirect all requests thataway.
    window.location.replace(
      `${window.VUE_DASHBOARD_ROOT}/broadcasts/${window.location.hash.replace('#/events/', '')}`
    );
    return;

    if (this.queryParams.from_producer === 'true') {
      $timeout(() => {
        toaster.pop('success', 'Thank you for streaming with Producer');
      });
    }

    const { ApiConfig } = $rootScope;
    const FeatureFlags = $rootScope.account.feature_flags;
    this.channelMap = {};
    this.channels = Channel.query({ l: 1000 }, () => {
      this.channels.forEach((c) => (this.channelMap[c.id] = c));
    });

    this.enableScoreboardControls = false;
    this.showRtmpConfig = false;
    this.isTriCaster = navigator.userAgent.indexOf('Tricaster') > 0;
    this.activeOverlays = [];

    this.FeatureFlags = FeatureFlags;
    this.canCreate = this.user.can('create', 'broadcast');
    this.canEdit = this.user.can('update', 'broadcast/*');
    this.canUpload = this.user.can('create', 'broadcast/*:upload');
    this.sports = ApiConfig.stream.sports;
    this.hasAnalyticsFeature = !!FeatureFlags.analytics;
    this.allowEmbed = this.user.can('embed', 'broadcast/*');
    this.allowPromote =
      this.user.can('promote', 'broadcast/*') &&
      !this.account.extra_features.media_token_restrictions;
    this.allowSimulatedLive = !!FeatureFlags.simulated_live;
    this.allowHighlights = this.user.can('list', 'broadcast/*:highlights');
    this.allowOverlays =
      FeatureFlags.overlays && this.user.can('update', 'broadcast/*:metadata/overlays');
    this.allowLiveAutomatedCaptioning = FeatureFlags.live_automated_captioning;

    // allowSocial is complicated... it will be determined after the broadcast is loaded in fixBroadcast() => computeAllowSocial()
    this.allowSocial = false;

    this.activeDestinationStatus = {};
    this.activeDestinationDetails = {};
    this.toggleActiveDestinationDetails = (i) => {
      this.activeDestinationDetails[i] = !this.activeDestinationDetails[i];
    };

    this.onStreamDiagnosticsReload = (data) => {
      // For static RTMP broadcasts, if stream diagnostics reports a change in standard, then reload the
      // static RTMP with diagnostics; this will update our source icon with the latest information.
      if (
        this.broadcast &&
        this.broadcast.stream_source == 'rtmp' &&
        this.broadcast.static_rtmp_id
      ) {
        const lastRTMPStandard = (this.streamDiagnostics || {}).last_rtmp_standard || '';
        const newRTMPStandard = (data || {}).last_rtmp_standard || '';
        if (lastRTMPStandard != newRTMPStandard) {
          StaticRTMP.get({ id: this.broadcast.static_rtmp_id, include_diagnostics: true }, (r) => {
            this.staticRTMPDiagnostics = r.diagnostics;
          });
        }
      }

      this.streamDiagnostics = data;

      // reconcile active simulcast destinations against the stream diagnostics data
      if ((this.broadcast || {}).simulcast_configurations) {
        this.broadcast.simulcast_configurations.forEach((s, i) => {
          var possibleConfiguredUrls = [
            `${s.rtmps_url}/${s.stream_key}`,
            `${s.rtmp_url}/${s.stream_key}`,
            s.fb_secure_stream_url,
            s.fb_stream_url,
          ];
          if (s.stream_url) {
            possibleConfiguredUrls.push(
              `${SanitizeRTMPURL(s.stream_url)}/${encodeURIComponent(s.stream_key)}`
            );
          }
          if (data.data_version >= 3) {
            _.each(data.raw_stats.simulcast_frame_rate || {}, (s, rtmpURL) => {
              const sanitizedURL = SanitizeRTMPURL(rtmpURL);
              possibleConfiguredUrls.forEach((url) => {
                if (sanitizedURL == url && !!s && !!s.video && s.video.length > 0) {
                  const fps = s.video[s.video.length - 1][1];
                  this.activeDestinationStatus[i] = {
                    connected: fps > SIMULCAST_FPS_THRESHOLD,
                    fps: fps,
                  };
                }
              });
            });
          } else {
            var influxSeries =
              (data.raw_stats.results &&
                data.raw_stats.results[4] &&
                data.raw_stats.results[4].series) ||
              [];
            influxSeries.forEach((d) => {
              var seriesUrl = (d.tags || {}).rtmp_url;
              possibleConfiguredUrls.forEach((url) => {
                if (seriesUrl == url) {
                  var fps;
                  var values = d.values || [];
                  if (values.length > 1) {
                    fps = values[values.length - 2][1]; //2nd from last accounts for a "full" period
                  } else {
                    fps = (values[values.length - 1] || [0, 0])[1];
                  }
                  this.activeDestinationStatus[i] = {
                    connected: fps > SIMULCAST_FPS_THRESHOLD,
                    fps: fps,
                  };
                }
              });
            });
          }
        });
      }

      this.computeBroadcastStatus();
    };

    if (
      this.user.can('list', 'broadcast/*:captions') &&
      this.user.can('create', 'broadcast/*:caption') &&
      this.user.can('read', 'broadcast/*:caption/*') &&
      this.user.can('update', 'broadcast/*:caption/*')
    ) {
      this.allowCaptions = true;
    }

    if (FeatureFlags.cue_points) {
      this.cue = {};
    }
    if (FeatureFlags.documents) {
      this.documents = {};
    }

    this.graphType = 'fine';

    if (this.allowOverlays) {
      this.loadUploadsForPage(1);
    }

    this.reload(true)
      .then((res) => {
        /**
         * Wait until after the broadcast has loaded, then check If the user has edit permissions
         * if so, open the edit dialog
         */
        if (this.queryParams.action === 'open_edit') {
          this.edit();
        }
      })
      .catch((err) => {
        console.error(err);
      });

    // Support auto-reloading of page silently
    this._reloadHandle = $timeout(() => this.reloadSilent(), REFRESH_INTERVAL_MS);
    $scope.$on('$destroy', () => {
      $timeout.cancel(this._reloadHandle);
      $timeout.cancel(this._calculateRecordingUploadHandle);
      $timeout.cancel(this._captionReloadHandle);
      this.BandwidthTestClient.cancelIfInFlight();
    });

    // Workaround for binding scope issue
    this.onOverlayChange = this.onOverlayChange.bind(this);
    this.saveOverlays = this.saveOverlays.bind(this);

    this.reloadPlayerMeta = () => $scope.$broadcast('boxcast:refreshMeta');
  }

  get sanitizedDescription() {
    return this.$sanitize(this.broadcast.description);
  }

  ///
  /// Recording Uploads
  ///

  get canDownloadOrExport() {
    const { user } = this;

    // If the user is not capable of creating any download or export, then don't show it
    if (
      user.cannot('create', 'recording/*:download') &&
      user.cannot('create', 'recording/*:kaltura-export') &&
      user.cannot('create', 'recording/*:vimeo-export') &&
      user.cannot('create', 'recording/*:youtube-export')
    ) {
      return false;
    }

    // If there's no transcoded recording, then don't show it.
    if (!this.recordingIsTranscoded) {
      return false;
    }

    return true;
  }

  get recordingIsAvailable() {
    return (
      this.broadcast.timeframe === 'past' &&
      (this.broadcast.stream_source === 'imported' ||
        (this.publicView && this.publicView.status && this.publicView.status === 'recorded'))
    );
  }

  get storageIsExpired() {
    return (
      this.publicView &&
      this.publicView.status &&
      this.publicView.status === 'not_recorded' &&
      _.contains(['expired', 'purged'], this.publicView.reason)
    );
  }

  get recordingUploadMostRecent() {
    if (!this.recordingUploads || !this.recordingUploads.length) return null;
    return this.recordingUploads[0];
  }

  get recordingUploadStatus() {
    return (this.recordingUploadMostRecent || {}).status;
  }

  get recordingUploadFailureReason() {
    return (this.recordingUploadMostRecent || {}).failure_reason;
  }

  get recordingUploadProgress() {
    if (!this.recordingUploads || !this.recordingUploads.length) return null;
    if (this.recordingUploadStatus == 'failed') return null;
    return this.recordingUploads[0].progress;
  }

  get recordingIsTranscoded() {
    if (!this.broadcast) {
      return false;
    } else if (this.broadcast.recording_id && this.broadcast.recording_duration_seconds) {
      return true;
    } else {
      return false;
    }
  }

  get recordingIsBeingUploaded() {
    if (!this.broadcast) {
      return false;
    } else if (!this.broadcast.recording_id && this.broadcast.stream_source == 'imported') {
      return true;
    } else {
      return false;
    }
  }

  get recordingIsBeingReplaced() {
    if (!this.broadcast || !this.recordingUploads || !this.recordingUploads.length) {
      return false;
    } else if (
      this.broadcast.recording_id &&
      ['created', 'uploaded', 'assigned', 'processing', 'failed'].indexOf(
        this.recordingUploadStatus
      ) >= 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  get recordingIsWaitingToBePublished() {
    if (!this.broadcast || !this.recordingUploads || !this.recordingUploads.length) {
      return false;
    } else if (
      this.broadcast.recording_id &&
      this.broadcast.stream_source == 'imported' &&
      this.recordingUploadStatus == 'completed' &&
      this.broadcast.is_private
    ) {
      return true;
    } else {
      return false;
    }
  }

  get recordingUploadStatusMessage() {
    // Support normal upload workflow
    const s = this.recordingUploadStatus;
    if (!s) return null;
    if (s == 'failed') {
      let reason = this.recordingUploadFailureReason;
      if (reason == 'transcode_failed') {
        return `Video failed to process due to an error transcoding your video. Please verify the file is the correct format before trying again.`;
      } else if (reason == 'internal_server_error') {
        return `Video failed to process due to an internal server error.`;
      } else if (
        _.contains(reason, 'CannotStartContainerError') &&
        _.contains(reason, 'ThrottlingException')
      ) {
        return `Video failed to process due to an internal error allocating a server for processing the upload.`;
      } else if (reason) {
        return `Video failed to process: ${reason}.`;
      } else {
        return 'Video failed to process. Please verify the file is the correct format before trying again.';
      }
    }
    return (
      {
        created: 'Video has not finished uploading',
        uploaded: 'Video is waiting to be processed',
        assigned: 'Video is about to be processed',
        processing: 'Video is being transcoded',
        completed: 'Video will be ready momentarily',
      }[s] || 'Video upload status is unknown'
    );
  }

  get recordingReplacementStatusMessage() {
    const s = this.recordingUploadStatus;
    if (!s) return null;
    if (s == 'failed') {
      let reason = this.recordingUploadFailureReason;
      if (reason == 'transcode_failed') {
        return `Video failed to process due to an error transcoding your video. Please verify the file is the correct format before trying again.`;
      } else if (reason == 'internal_server_error') {
        return `Video failed to process due to an internal server error.`;
      } else if (
        _.contains(reason, 'CannotStartContainerError') &&
        _.contains(reason, 'ThrottlingException')
      ) {
        return `Replacement video failed to process due to an internal error allocating a server for processing the upload.`;
      } else if (reason) {
        return `Replacement video failed to process: ${reason}.`;
      } else {
        return 'Replacement video failed to process. Please verify the file is the correct format before trying again';
      }
    }
    return (
      {
        created: 'Replacement video has not finished uploading',
        uploaded: 'Replacement video is waiting to be processed',
        assigned: 'Replacement video is about to be processed',
        processing: 'Replacement video is being transcoded',
        completed: 'Replacement video will be ready momentarily',
      }[s] || 'Replacement video upload status is unknown'
    );
  }

  get recordingProcessingEstimate() {
    return estimateProcessingTimeRemaining({
      broadcast: this.broadcast,
      upload: this.recordingUploadMostRecent,
    });
  }

  get emailMeWhenComplete() {
    return (
      ((this.broadcast || {}).metadata || {})['notify:uploaded_completed_email'] == this.user.email
    );
  }

  get showHighlights() {
    return (
      this.allowHighlights &&
      (this.broadcast.recording_requested || this.broadcast.stream_source == 'imported') &&
      ((this.recordingIsTranscoded && !this.storageIsExpired) ||
        this.broadcast.timeframe == 'current')
    );
  }

  set emailMeWhenComplete(val) {
    const { user, Broadcast, toaster } = this;
    var metadata = this.broadcast.metadata || {};
    if (val) {
      metadata['notify:uploaded_completed_email'] = user.email;
    } else {
      metadata['notify:uploaded_completed_email'] = undefined;
    }
    Broadcast.update(
      { id: this.broadcast.id },
      { metadata: metadata },
      (b) => this.setBroadcast(b),
      (e) => {
        console.error(e);
        toaster.pop('warning', `Unable to add ${user.email} to notification for upload`);
        this.reloadSilent();
      }
    );
  }

  get producerBroadcastURL() {
    return window.VUE_DASHBOARD_ROOT + '/producer/' + this.broadcast.id;
  }

  loadRecordingUploads() {
    const { $http, toaster, $timeout } = this;
    $http
      .get(`${API_ROOT}/account/broadcasts/${this.$state.params.id}/uploads`)
      .then((response) => {
        this.recordingUploads = response.data;
      })
      .then(() => {
        $timeout.cancel(this._calculateRecordingUploadHandle);
        if (this.recordingIsBeingUploaded || this.recordingIsBeingReplaced) {
          this._calculateRecordingUploadHandle = $timeout(() => {
            this.loadRecordingUploads();
          }, UPLOAD_PROGRESS_INTERVAL_MS);
        }
      })
      .catch((e) => {
        toaster.pop('warning', 'Could not load recording uploads');
      });
  }

  uploadReplacement() {
    const { $uibModal } = this;
    $uibModal
      .open({
        template: require('./modal-upload-event.html'),
        controllerAs: 'vm',
        controller: ModalUploadEventController,
        size: 'lg',
        //  Prevent accidental close...
        backdrop: 'static',
        keyboard: false,
        resolve: {
          broadcast: () => this.broadcast,
          highlights: () => this.highlights,
        },
      })
      .result.then((b) => {
        this.reloadSilent();
      });
  }

  cancelUpload() {
    if (confirm('Do you wish to cancel this upload?')) {
      const { $http, toaster, $timeout, recordingUploadMostRecent } = this;
      $http
        .put(
          `${API_ROOT}/account/broadcasts/${this.$state.params.id}/uploads/${recordingUploadMostRecent.id}`,
          {
            status: 'canceled',
          }
        )
        .then(() => {
          this.loadRecordingUploads();
        })
        .catch((e) => {
          toaster.pop('warning', 'Could not cancel upload. Please refresh and try again.');
        });
    }
  }

  ///
  /// Overlays
  ///

  loadUploadsForPage(p) {
    const { Overlays, toaster } = this;
    this.uploadsPromise = Overlays.loadOverlaysForPage(p)
      .then((result) => {
        this.uploads = result.uploads;
        this.uploadsPagination = result.pagination;
      })
      .catch((err) => {
        toaster.pop('warn', 'Unable to load overlay image gallery.');
      });
  }

  uploadOverlay(file) {
    file.upload().then((result) => {
      console.log('Overlay image uploaded', result);
      this.file = null;
      this.loadUploadsForPage(1);
    });
  }

  addOverlay(upload, replace = false) {
    var { Overlays, activeOverlays, uploads, $rootScope, toaster } = this;
    upload.__showOverlay = false;
    Overlays.prepareUploadForOverlay(upload)
      .then((overlay) => {
        if (replace) {
          uploads.forEach((u) => (u.__inUse = false));
          while (activeOverlays.length) {
            activeOverlays.pop();
          }
        }
        activeOverlays.push(overlay);
        upload.__inUse = true;
        this.overlaysChanged = true;
      })
      .catch((err) => {
        console.error(err);
        toaster.pop('warn', 'Unable to select overlay image.');
      });
  }

  deleteUpload(upload) {
    const { ConfirmDialog, AccountUploadsService, toaster } = this;
    upload.__showOverlay = false;

    let modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Delete Image From Gallery',
      actionButtonClass: 'danger',
      headerText: 'Please Confirm',
      bodyText:
        'Are you sure you want to delete this image from your gallery? It will no longer be accessible.',
    };

    ConfirmDialog.show(modalOptions).then(() => {
      AccountUploadsService.deleteUpload(upload)
        .then(() => {
          toaster.pop('success', 'The image was successfully deleted.');
        })
        .then(() => {
          this.loadUploadsForPage(1);
        })
        .catch((error) => {
          console.error(error);
          toaster.pop(
            'warning',
            'An error occurred while trying to delete the image. Please refresh and try again.'
          );
        });
    });
  }

  removeOverlay(upload) {
    upload.__showOverlay = false;
    _.remove(this.activeOverlays, { url: upload.view_url });
    upload.__inUse = false;
    this.overlaysChanged = true;
  }

  onOverlayChange(overlay, attrs) {
    var i = this.activeOverlays.indexOf(overlay);
    if (i < 0) {
      console.warn('Unable to locate changed overlay', overlay, 'in', this.activeOverlays);
      return;
    }
    _.assign(this.activeOverlays[i], attrs);
    this.overlaysChanged = true;
  }

  restoreOverlaysFromMetadata() {
    if (!this.allowOverlays) return;
    if (!this.overlaysChanged) {
      this.activeOverlays = angular.copy((this.broadcast.metadata || {}).overlays || []); //make copy so that we can restore later
      this.activeOverlays.forEach((o) => {
        this.uploadsPromise.then(() => {
          _.where(this.uploads, { view_url: o.url }).forEach((u) => (u.__inUse = true));
        });
      });
    }
  }

  discardOverlays() {
    this.overlaysChanged = false;
    this.uploads.forEach((u) => (u.__inUse = false));
    this.restoreOverlaysFromMetadata();
  }

  saveOverlays() {
    const { Broadcast, broadcast, toaster } = this;
    var metadata = broadcast.metadata || {};
    metadata.overlays = this.activeOverlays;
    this.overlaysSaving = true;
    Broadcast.update(
      { id: this.broadcast.id },
      { metadata: metadata },
      (b) => {
        this.overlaysChanged = false;
        this.overlaysSaving = false;
        this.setBroadcast(b);
        toaster.pop('success', 'Overlay activated.');
      },
      (err) => {
        this.overlaysSaving = false;
        console.error(err);
        toaster.pop('warning', `Unable to activate overlays. Please refresh and try again.`);
      }
    );
  }

  ///
  /// Cue Points
  ///

  addCue() {
    const { Broadcast } = this;

    if (!this.cue.name) {
      this.toaster.pop('warning', 'Please enter a title for the video index entry');
      return;
    }

    var timestamp = this.clapprUtils.getCurrentTime();
    var segmentAndOffset = this.clapprUtils.getPlayerSegmentAndOffsetForTime(timestamp);
    console.log(segmentAndOffset);
    if (!segmentAndOffset) {
      this.toaster.pop(
        'warning',
        'Please make sure the start time is within the valid range of the video.'
      );
      return;
    }

    var content_settings = this.broadcast.content_settings || {};
    content_settings.cues = angular.copy(content_settings.cues || []);
    content_settings.cues.push({
      name: this.cue.name,
      description: '',
      playback_start_time_fmt: secondsToFormattedLabel(timestamp), // XXX: TODO: can we map to VOD timestamp when live?
      segment: segmentAndOffset[0],
      time_offset_in_segment: segmentAndOffset[1],
    });
    content_settings.cues = _.sortBy(content_settings.cues, 'playback_start_time_fmt');

    Broadcast.update({ id: this.$state.params.id }, { content_settings: content_settings })
      .$promise.then((b) => {
        this.toaster.pop('success', 'Saved video index entry');
        this.setBroadcast(b);
        this.reloadPlayerMeta();
        this.cue.name = '';
      })
      .catch((err) => {
        this.toaster.pop(
          'warning',
          'Unable to save video index entry, please check your entry and try again.'
        );
        console.error(err);
      });
  }

  seekCue(c) {
    this.player.seek(formattedLabelToSeconds(c.playback_start_time_fmt));
    this.player.play();
  }

  deleteCue(c) {
    const { Broadcast } = this;
    var idx = this.broadcast.content_settings.cues.indexOf(c);
    if (idx < 0) {
      this.toaster.pop(
        'warning',
        'Unable to delete video index entry, please refresh and try again.'
      );
      return;
    }
    var cs = angular.copy(this.broadcast.content_settings);
    cs.cues.splice(idx, 1);
    Broadcast.update({ id: this.$state.params.id }, { content_settings: cs })
      .$promise.then((b) => {
        this.toaster.pop('success', 'Deleted video index entry');
        this.setBroadcast(b);
        this.reloadPlayerMeta();
      })
      .catch((err) => {
        this.toaster.pop(
          'warning',
          'Unable to delete video index entry, please refresh and try again.'
        );
        console.error(err);
      });
  }

  editCue(c) {
    const { Broadcast } = this;
    delete c.__enableEditMode;
    Broadcast.update(
      { id: this.$state.params.id },
      { content_settings: this.broadcast.content_settings }
    )
      .$promise.then((b) => {
        this.toaster.pop('success', 'Saved video index entry');
        this.setBroadcast(b);
        this.reloadPlayerMeta();
      })
      .catch((err) => {
        this.toaster.pop(
          'warning',
          'Unable to save video index entry, please check your entry and try again.'
        );
        console.error(err);
      });
  }

  ///
  /// Documents
  ///

  saveDocument(d, file) {
    const { Broadcast, toaster } = this;
    if (!file) {
      toaster.pop('warning', 'Please select a file');
      return;
    }
    if (!d || !d.name || !d.name.trim()) {
      toaster.pop('warning', 'Please enter a valid document name');
      return;
    }
    file.upload().then((result) => {
      console.log('Document uploaded', result);
      var cs = angular.copy(this.broadcast.content_settings) || {};
      cs.documents = cs.documents || [];
      cs.documents.push({
        name: d.name,
        url: result.view_url,
      });
      Broadcast.update({ id: this.$state.params.id }, { content_settings: cs })
        .$promise.then((b) => {
          toaster.pop('success', 'Successfully uploaded document');
          this.setBroadcast(b);
          this.newDocumentFile = null;
        })
        .then(() => {
          this.document = {};
        })
        .catch((err) => {
          toaster.pop(
            'warning',
            'Unable to upload document, please check your entry and try again.'
          );
          console.error(err);
        });
    });
  }

  deleteDocument(d) {
    const { Broadcast, ConfirmDialog } = this;

    let modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Remove Document',
      actionButtonClass: 'danger',
      headerText: 'Please Confirm',
      bodyText: 'Are you sure you want to remove this document from the broadcast?',
    };

    ConfirmDialog.show(modalOptions).then(() => {
      var idx = this.broadcast.content_settings.documents.indexOf(d);
      if (idx < 0) {
        this.toaster.pop(
          'warning',
          'Unable to delete document, please check your entry and try again.'
        );
        return;
      }
      var cs = angular.copy(this.broadcast.content_settings);
      cs.documents.splice(idx, 1);
      Broadcast.update({ id: this.$state.params.id }, { content_settings: cs })
        .$promise.then((b) => {
          this.toaster.pop('success', 'Deleted document');
          this.setBroadcast(b);
        })
        .catch((err) => {
          this.toaster.pop(
            'warning',
            'Unable to delete document, please check your entry and try again.'
          );
          console.error(err);
        });
    });
  }

  editDocument(d) {
    const { Broadcast } = this;
    delete d.__enableEditMode;
    Broadcast.update(
      { id: this.$state.params.id },
      { content_settings: this.broadcast.content_settings }
    )
      .$promise.then((b) => {
        this.toaster.pop('success', 'Saved document');
        this.setBroadcast(b);
      })
      .catch((err) => {
        this.toaster.pop(
          'warning',
          'Unable to save document, please check your entry and try again.'
        );
        console.error(err);
      });
  }

  ///
  /// Captions
  ///

  startCaptioning(upload = null) {
    const { Caption, toaster } = this;

    var data = { source: 'on-demand' };
    if (upload != null) {
      data = {
        source: 'uploaded',
        status: 'complete',
        cues: upload.cues.map((c) => {
          return {
            start_time: c.startTime,
            end_time: c.endTime,
            text: c.text,
            confidence: 1.0,
          };
        }),
      };
    }

    Caption.create({ broadcast_id: this.broadcast.id }, data)
      .$promise.then(() => {
        toaster.pop('success', 'Successfully started captioning.');
        this.safeReloadCaptions();
      })
      .catch((err) => {
        toaster.pop('warning', 'Unable to start captioning. Please refresh and try again.');
        console.error(err);
      });
  }

  safeReloadCaptions() {
    const { Caption, $timeout, toaster } = this;
    if (!this.allowCaptions) {
      return;
    }

    const CAPTION_RELOAD_INTERVAL_MS = 30000;

    this.loadingCaptions = true;
    Caption.query(
      { broadcast_id: this.$state.params.id },
      (captions) => {
        this.loadingCaptions = false;
        this.caption = null;

        _.each(captions, (c) => {
          if (c.recording_id === this.broadcast.recording_id) {
            this.caption = c;
          }
        });

        if (this.caption) {
          if (this.caption.status != 'completed' && this.caption.status != 'failed') {
            this._captionReloadHandle = $timeout(
              () => this.safeReloadCaptions(),
              CAPTION_RELOAD_INTERVAL_MS
            );
          }
          if (this.caption.cues) {
            this.captionTranscipt = this.caption.cues
              .map((c) => {
                return `${secondsToFormattedLabel(c.start_time)}   ${c.text}`;
              })
              .join('\n');
          }
        }
      },
      (err) => {
        console.error(err);
        this.loadingCaptions = false;
        toaster.pop(
          'warning',
          'Unable to load captions',
          'There was an issue loading the captions for the broadcast. Please reload and try again.'
        );
      }
    );
  }

  downloadCaption(format) {
    const { Caption, toaster } = this;
    Caption.render(
      { broadcast_id: this.$state.params.id, id: this.caption.id, format: format },
      (response) => {
        var extension = format === 'text' ? 'txt' : 'vtt';
        var filename = this.$state.params.id + '_captions.' + extension;
        forceBrowserDownload(URL.createObjectURL(response.blob), filename);
      },
      (err) => {
        console.error(err);
        toaster.pop(
          'warning',
          'Unable to download captions',
          'There was an issue downloading the captions for the broadcast. Please reload and try again.'
        );
      }
    );
  }

  get canEnterProducer() {
    const { account } = this;
    return account.feature_flags.producer;
  }

  ///
  /// RTMP
  ///

  get canUsePreview() {
    const { account } = this;
    // Low-latency preview is gated by feature flag PLUS browser-compatibility
    // Note that we're not feature-detecting Flash specifically (although we could)
    // because this allows us to advertise to desktop users who might only have
    // to install the flash plugin to get it to work.
    if (!account.extra_features.low_latency_preview) {
      return false;
    }
    if (navigator.userAgent.indexOf('iOS') >= 0 || navigator.userAgent.indexOf('Android') >= 0) {
      return false;
    }
    if ((this.broadcast || {}).actual_codec == 'hevc') {
      return false;
    }
    return !!(this.broadcast || {}).rtmp_preview_url;
  }

  configureRTMP() {
    if (this.broadcast.stream_source != 'rtmp' && this.broadcast.stream_source != 'switcher') {
      this.showRtmpConfig = false;
      return;
    }

    this.rtmpVideoParams = resolutionForBroadcast(this.broadcast);
    this.rtmpVideoParams.framerate = 30;
    if (this.FeatureFlags.high_frame_rate && this.broadcast.target_high_frame_rate === true) {
      this.rtmpVideoParams.framerate = 60;
    }

    if (this.broadcast.static_rtmp_id || this.broadcast.rtmp_ingestion_url) {
      // If we have static RTMP, or API has already assigned the single-use address, go ahead
      // and show settings unless broadcast is already over.
      this.showRtmpConfig = this.broadcast.timeframe != 'past';
    } else {
      // For Generic RTMP, we won't have the RTMP config until at least pre-roll, but we also
      // need to take the extra step of making a stream.  Go ahead and try that as long as we're
      // eligible to based ont he timeframe. Note that static RTMP channels do this automagically.
      this.showRtmpConfig = false;
    }
  }

  _openRtmpModal(encoderType) {
    const { BandwidthTestClient } = this;

    const RUN_TEST_EVERY_TIME = false; //useful for testing

    const showFullRTMPSettingsModal = () => {
      this.$uibModal.open({
        template: require('./modal-rtmp.html'),
        controllerAs: 'vm',
        controller: BroadcastWithRtmpController,
        size: 'lg',
        resolve: {
          availableBandwidth: () => this.availableBandwidth,
          broadcast: () => this.broadcast,
          encoderType: () => encoderType,
        },
      });
    };

    if (this.availableBandwidth && !RUN_TEST_EVERY_TIME) {
      showFullRTMPSettingsModal();
    } else {
      this.BandwidthTestClient.cancelIfInFlight();
      this.$uibModal
        .open({
          template: `
        <div class="modal-header">
          <button type="button" class="close" ng-click="vm.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h3>Testing Bandwidth</h3>
        </div>
        <div class="modal-body text-center">
          <p>Please wait while we run a bandwidth test to determinte appropriate settings.</p>
          <h1>
            <small>ESTIMATED UPLOAD SPEED</small>
            <span class="throb-in-progress" style="display:inline-block;min-width:175px;text-align:right;font-weight:bold;">
              {{vm.estimatedBandwidth|bits}}ps
            </span>
          </h1>
        </div>
        `,
          controllerAs: 'vm',
          controller: function ($uibModalInstance, $timeout) {
            'ngInject';
            this.close = () => $uibModalInstance.dismiss('cancel');
            this.estimatedBandwidth = 0;
            this.onProgress = (stats) => {
              $timeout(() => {
                this.estimatedBandwidth = stats.estimatedBandwidth;
                if (isNaN(this.estimatedBandwidth) || this.estimatedBandwidth < 0) {
                  this.estimatedBandwidth = 0;
                }
              }, 0);
            };
            BandwidthTestClient.runTestOrUseRecentCached(this.onProgress, RUN_TEST_EVERY_TIME).then(
              (result) => {
                var delay = result.fromCache ? 0 : 1000;
                $timeout(() => {
                  $uibModalInstance.close(result);
                }, delay);
              }
            );
          },
          size: 'lg',
        })
        .result.then((result) => {
          this.availableBandwidth = result.availableBandwidth;
          showFullRTMPSettingsModal();
        });
    }
  }

  tricaster() {
    this._openRtmpModal('TriCaster');
  }

  rtmp() {
    this._openRtmpModal('Other Encoder');
  }

  ///
  /// Misc
  ///

  get showDiagnostics() {
    if (!this.broadcast) return false;
    return this.broadcast.timeframe != 'future' && this.broadcast.stream_source != 'imported';
  }

  get activeLiveAutomatedCaptions() {
    // A broadcast has active live, automated captions if:
    //  - live automated captioning is allowed;
    //  - the broadcast requests captioning; and
    //  - the broadcast is current or preroll,
    if (!this.allowLiveAutomatedCaptioning) return false;
    if (!this.broadcast.requests_captioning) return false;
    return ['preroll', 'current'].indexOf(this.broadcast.timeframe) >= 0;
  }

  get showCaptionsTab() {
    // If captions aren't allowed, don't show the tab
    if (!this.allowCaptions) return false;

    // If recordingIsAvailable, then the user can do captions things, so show the tab.
    if (this.recordingIsAvailable) return true;

    // If we get here, the only reason to show the tab is if the broadcast has active live
    // automated captions and the user can edit the broadcast.
    return this.activeLiveAutomatedCaptions && this.canEdit;
  }

  get showRecordingControls() {
    return (
      ((this.canEdit || this.canCreate) &&
        this.publicView &&
        this.broadcast.timeframe == 'past' &&
        !this.storageIsExpired) ||
      this.showReplayViaSimulatedLive
    );
  }

  get showUploadReplacement() {
    return (
      this.canUpload &&
      this.broadcast.timeframe == 'past' &&
      this.broadcast.stream_source != 'recording' &&
      !this.broadcast.do_not_record
    );
  }

  get showEditHighlightClips() {
    return this.showHighlights && this.recordingIsTranscoded;
  }

  get showReplayViaSimulatedLive() {
    return (
      this.allowSimulatedLive &&
      (this.broadcast.timeframe != 'past' || (this.recordingIsAvailable && this.recordingIsV2a))
    );
  }

  get boxCasterStatusLabel() {
    // get the status label CSS class ... only shown for future/current broadcasts
    if (!this.boxcaster) {
      return 'unknown';
    }
    // boxcaster statuses include:
    // * unregistered probing decommissioned (admin only)
    // * ready preparing_broadcast broadcasting
    // * offline
    // boxcaster warnings include:
    // * no_video_input updating_firmware
    // * none
    if (this.broadcast.timeframe == 'future') {
      // Future broadcasts are OK to be in strange states
      if (['broadcasting', 'preparing_broadcast', 'ready'].indexOf(this.boxcaster.status) >= 0) {
        return 'connected';
      } else {
        return 'unknown';
      }
    } else {
      // If the timeframe is current/preroll, it's a warning to be anything other than broadcasting/preparing
      if (['broadcasting', 'preparing_broadcast'].indexOf(this.boxcaster.status) >= 0) {
        if (this.boxcaster.next_broadcast_id != this.broadcast.id) {
          // Special case of "broadcasting" but with some *other* broadcast
          return 'warning';
        } else if (this.boxcaster.warning && this.boxcaster.warning != 'none') {
          return 'warning';
        } else {
          return 'connected';
        }
      } else {
        return 'warning';
      }
    }
  }

  diagnosticsIconStyle(s, idx) {
    if (s.status === 'error') {
      return 'warning';
    } else if (this.activeDestinationStatus[idx] && this.activeDestinationStatus[idx].connected) {
      return 'connected';
    }
    return '';
  }

  setBroadcast(broadcast) {
    // If the broadcast is going from non-past to past and the captions tab is selected, select the
    // overview tab to avoid a goofy interim state in the captions tab.
    if (
      this.broadcast.timeframe !== 'past' &&
      broadcast.timeframe === 'past' &&
      this.activeTab === 'captions'
    ) {
      this.changeTab('');
    }
    this.broadcast = broadcast;
    this.fixBroadcast();
    this.computeBroadcastStatus();
  }

  reloadSilent() {
    const { $timeout, FeatureFlags } = this;

    $timeout.cancel(this._reloadHandle);

    this.Broadcast.get(
      { id: this.$state.params.id },
      (b) => {
        this.setBroadcast(b);
        this._reloadHandle = $timeout(() => this.reloadSilent(), REFRESH_INTERVAL_MS);
      },
      (error) => {
        console.error('Unable to reload broadcast metadata, will try again.', error);
        this._reloadHandle = $timeout(() => this.reloadSilent(), REFRESH_INTERVAL_MS);
      }
    );
  }

  reload(firstTime) {
    return new Promise((resolve, reject) => {
      const { $timeout, FeatureFlags } = this;
      const { id } = this.$state.params;

      this.broadcast = this.Broadcast.get(
        { id: id },
        (b) => {
          this.setBroadcast(b);
          this.safeReloadCaptions();
          this.playerOptions = {
            autoplay: false,
            ticketId: this.ticketId,
            onLoadBroadcast: () => {
              $timeout(() => {
                const { SelectedBroadcastStore } = boxcast.model;
                this.publicView = SelectedBroadcastStore.view;
                this.publicBroadcast = SelectedBroadcastStore.broadcast;
                this.computeBroadcastStatus();
                // The first time this is loaded, if the captions tab was requested via URL and it's
                // now able to be shown (showCaptionsTab depends on publicView), select it.
                if (firstTime && this.$state.params.tab === 'captions' && this.showCaptionsTab) {
                  this.activeTab = this.$state.params.tab;
                }
              }, 0);
            },
            onRefresh: (SelectedBroadcastStore) => {
              // Player refreshed its metadata; keep dashboard in sync
              this.reloadSilent();
              $timeout(() => {
                this.publicView = SelectedBroadcastStore.view;
                this.publicBroadcast = SelectedBroadcastStore.broadcast;
                this.computeBroadcastStatus();
              }, 0);
            },
            onLoadPlayer: (player) =>
              $timeout(() => {
                this.player = player;
                this.clapprUtils = new ClapprUtils(player);

                if (this.clapprUtils.isUsingHlsJs() && this.broadcast.recording_id) {
                  this.isUsingHlsJsOnRecording = true;
                }
              }, 0),
          };
          if (
            this.broadcast.scoreboard_configuration &&
            this.broadcast.scoreboard_configuration.sport &&
            this.broadcast.scoreboard_configuration.scoreboard_make === 'Manual'
          ) {
            this.enableScoreboardControls = true;
          }
          if (firstTime) {
            if (this.$state.params.tab && this.$state.params.tab !== 'captions') {
              this.activeTab = this.$state.params.tab;
            }
            if (
              this.$state.params.action &&
              this.$state.params.action === 'export' &&
              this.canDownloadOrExport
            ) {
              this.downloadOrExport();
            }
            this.fb.init();
          }
          resolve(b);
        },
        (error) => {
          if (error && error.data && error.data.error == 'not_found') {
            // If broadcast was not found, kick them back to home screen
            this.$state.go('home');
            this.toaster.pop('warning', `Broadcast ${id} could not be found`);
          } else if (error && error.data && error.data.error == 'gone') {
            // If broadcast was deleted, kick them back to home screen
            this.$state.go('home');
            this.toaster.pop('warning', `Broadcast ${id} was deleted`);
          } else {
            console.error(error);
            this.toaster.pop(
              'warning',
              `There was an error loading the broadcast. Please refresh the page and try again.`,
              '',
              0
            );
          }
          reject(error);
        }
      );

      this.highlights = this.Highlight.query(
        { broadcastId: this.$state.params.id, s: 'streamed_at' },
        (data, headers) => {
          var pagination = JSON.parse(headers('x-pagination'));
          this.totalHighlights = pagination.total;
        }
      );

      this.loadingPromises = [this.broadcast.$promise, this.highlights.$promise];
    });
  }

  computeAllowSocial() {
    const { FeatureFlags, account, broadcast } = this;
    this.allowSocial = AllowSocial(FeatureFlags, account, broadcast);
  }

  computeBroadcastStatus() {
    this.broadcastStatus = ComputeBroadcastStatus(
      this.broadcast,
      this.publicView,
      this.boxcaster,
      this.streamDiagnostics,
      this.staticRTMPDiagnostics
    );
  }

  fixBroadcast() {
    const { canUpload, BoxCaster, Broadcast, Recording, StaticRTMP, $http } = this;
    this.ticketId = '.' + this.broadcast.admin_token;
    this.generateEmailLink();
    this.restoreOverlaysFromMetadata();
    this.configureRTMP();
    if (canUpload) {
      this.loadRecordingUploads();
    }
    var cs = this.broadcast.content_settings || {};
    if (cs.agenda_url && !cs.documents) {
      this.broadcast.content_settings.documents = [
        { name: 'Agenda', url: this.broadcast.content_settings.agenda_url },
      ];
      delete this.broadcast.content_settings.agenda_url;
    }
    if (this.broadcast.stream_source == 'boxcaster' && this.broadcast.boxcaster_id) {
      BoxCaster.get({ id: this.broadcast.boxcaster_id }, (b) => {
        this.boxcaster = b;
        this.computeBroadcastStatus();
      });
    }
    if (this.broadcast.stream_source == 'rtmp' && this.broadcast.static_rtmp_id) {
      StaticRTMP.get({ id: this.broadcast.static_rtmp_id, include_diagnostics: true }, (r) => {
        this.staticRTMPDiagnostics = r.diagnostics;
      });
    }
    if (this.broadcast.stream_source === 'recording' && this.broadcast.source_broadcast_id) {
      if (!this.sourceBroadcast || this.sourceBroadcast.id !== this.broadcast.source_broadcast_id) {
        /**
         * We need to get the source broadcast if we have not already, or if the broadcast was edited and the source broadcast changed
         */
        Broadcast.get(
          { id: this.broadcast.source_broadcast_id },
          (b) => {
            this.sourceBroadcast = b;
            if (this.broadcast.timeframe !== 'past') {
              const durationSeconds = (this.sourceBroadcast || {}).recording_duration_seconds;
              if (durationSeconds) {
                this.broadcast.stops_at = moment(this.broadcast.starts_at)
                  .add(durationSeconds, 'seconds')
                  .toDate();
              }
            }
          },
          (e) => {
            if (e.status === 404 || e.status === 410) {
              this.sourceBroadcastUnavailable = true;
            } else {
              console.error(e);
            }
          }
        );
      } else if (this.broadcast.stops_at.indexOf('9999-12-31') === 0) {
        /**
         * this is not the functions first time running, so we already have the source broadcast, we just need to re-upate the stops_at to match source broadcast
         **/
        const durationSeconds = (this.sourceBroadcast || {}).recording_duration_seconds;
        if (durationSeconds) {
          this.broadcast.stops_at = moment(this.broadcast.starts_at)
            .add(durationSeconds, 'seconds')
            .toDate();
        }
      }
    }
    if (!this.simulatedLiveBroadcasts) {
      this.Broadcast.query(
        { 'filter.source_broadcast_id': this.broadcast.id, l: 1000, s: 'starts_at' },
        (results) => (this.simulatedLiveBroadcasts = results),
        (e) => console.error(e)
      );
    }
    if (this.broadcast.recording_id && !this.recordingSegments) {
      this.recordingSegments = Recording.segments(
        { id: this.broadcast.recording_id },
        (segments) => (this.recordingIsV2a = _.some(segments, (s) => s.byte_ranges))
      );
    }
    this.computeAllowSocial();

    const broadcastStartsAt = moment(this.broadcast.starts_at);
    const latestFacebookLiveScheduledEventTime = moment().add(7, 'days');
    this.canCreateFacebookLiveScheduledEvent =
      broadcastStartsAt < latestFacebookLiveScheduledEventTime;

    // Persist state values to allow 2-way binding separate from the computed properties
    this.showChatStateValue = this.showChat;
    this.enableCaptionsStateValue = this.enableCaptions;
  }

  youtubeEmbedUrl(config) {
    return this.$sce.trustAsResourceUrl(
      `https://www.youtube.com/embed/${config.youtube_broadcast_id}?autoplay=1`
    );
  }

  youtubeWatchUrl(config) {
    return this.$sce.trustAsResourceUrl(
      `https://www.youtube.com/watch/${config.youtube_broadcast_id}`
    );
  }

  periscopeWatchUrl(config) {
    return this.$sce.trustAsResourceUrl(config.share_url);
  }

  twitterWatchUrl(config) {
    return this.$sce.trustAsResourceUrl(config.share_url);
  }

  canShowFacebookLiveProducerURL(config) {
    // Can't show it if doesn't exist
    if (!config.live_producer_url) return false;

    // Can't show it if not logged in or for another user, as it won't work
    if (config.facebook_account_id != this.fb.facebook_account_id) return false;

    // Pretty sure the live producer page only works when the broadcast is scheduled
    return config.status == 'scheduled';
  }

  canShowFacebookPermalinkURL(config) {
    // Can't show it if it doesn't exist
    if (!config.permalink_url) return false;

    // XXX: https://developers.facebook.com/support/bugs/673296246903206/
    // XXX: https://www.facebook.com/business/help/2087325741287572?id=1123223941353904
    // The permalink_url doesn't actually go active until the live stream is live.
    return _.contains(['published', 'scheduled_live', 'stopping', 'stopped'], config.status);
  }

  createFacebookLiveScheduledEvent(config) {
    const { Broadcast, broadcast, toaster } = this;
    config.__updating = true;
    let promise = Broadcast.scheduleSimulcast({
      id: broadcast.id,
      simulcast_id: config.id,
    }).$promise;
    promise
      .then((response) => {
        _.assign(config, response);
      })
      .catch((e) => {
        console.error(e);
        toaster.pop(
          'warning',
          'Unable to schedule the Facebook Live event. Please check the status of your Facebook account on the settings page and try again.'
        );
      })
      .finally(() => {
        config.__updating = false;
      });
    this.loadingPromises.push(promise);
  }

  facebookLiveSimulcastFeedType(config) {
    return config.fb_feed_id.split(':', 1)[0];
  }

  facebookLiveSimulcastFeedID(config) {
    return config.fb_feed_id.replace(/^[^:]*:/, '');
  }

  createYouTubeEvent(config) {
    const { Broadcast, broadcast, toaster } = this;
    config.__updating = true;
    let promise = Broadcast.scheduleSimulcast({
      id: broadcast.id,
      simulcast_id: config.id,
    }).$promise;
    promise
      .then((response) => {
        _.assign(config, response);
      })
      .catch((e) => {
        console.error(e);
        this.toaster.pop(
          'warning',
          'Unable to create the linked YouTube event. Please check the status of your YouTube account on the settings page and try again.'
        );
      })
      .finally(() => {
        config.__updating = false;
      });
    this.loadingPromises.push(promise);
  }

  scheduleSimulatedLive() {
    this.$state.go('new-event', {
      streamSource: 'recording',
      sourceBroadcastId: this.broadcast.id,
    });
  }

  downloadOrExport() {
    const { $uibModal, broadcast, $analytics } = this;

    $uibModal.open({
      template: require('./modal-download-or-export-recording.html'),
      controllerAs: 'vm',
      controller: DownloadOrExportRecordingController,
      resolve: {
        broadcast: () => broadcast,
      },
    });
  }

  changeTab(newActiveTab) {
    if (newActiveTab != this.activeTab) {
      if (newActiveTab != '') {
        this.$location.search('tab', newActiveTab).replace();
      } else {
        this.$location.search('tab', null).replace();
      }
    }
    this.activeTab = newActiveTab;
  }

  edit(activeTab = null) {
    const { $uibModal, canEdit } = this;

    if (!canEdit) {
      console.warn('Not allowed to edit');
      return;
    }

    $uibModal
      .open({
        template: require('./edit.html'),
        controller: 'EditEventController',
        controllerAs: 'vm',
        resolve: {
          broadcastId: () => this.broadcast.id,
          activeTab: () => activeTab,
        },
      })
      .result.then((broadcast) => {
        //this.broadcast = broadcast;
        const params = { id: broadcast.id, tab: activeTab };
        if (this.queryParams.action === 'open_edit') {
          // the broadcast edit dialog was saved, we dont want it to re-open after the update has succeeded
          params.action = null;
        }
        // Refresh entire state of page (e.g. scoreboard)
        this.$state.go('events.detail', params, { reload: true });
      });
  }

  openHighlight(highlight) {
    const { Highlight, $uibModal } = this;

    let highlightDetails = Highlight.get({ broadcastId: this.broadcast.id, id: highlight.id });
    highlightDetails.$promise.then(() => {
      if (
        !this.broadcast.is_private &&
        this.broadcast.is_ticketed &&
        highlightDetails.duration > MAX_MONETIZED_HIGHLIGHT_TIME_S
      ) {
        // Can't preview -- open the editor
        $uibModal.open({
          size: 'lg',
          backdrop: 'static', // don't allow accidental clicks on backdrop to close
          template: require('./modal-capture-highlight-recorded.html'),
          controllerAs: 'vm',
          controller: CaptureOrEditHighlightController,
          resolve: {
            highlightObj: () => highlightDetails,
            recordingId: () => this.broadcast.recording_id,
          },
        });
      } else {
        // Open the preview
        const modalInstance = this.openHighlightPreviewModal(highlightDetails);
        modalInstance.closed.then(() => {
          // Refresh highlights in case the user deleted this one in the modal.
          this.highlights = this.Highlight.query({ broadcastId: this.broadcast.id });
        });
      }
    });
  }

  openHighlightPreviewModal(highlightDetails, showSave = false) {
    const { $uibModal } = this;

    return $uibModal.open({
      template: require('./modal-highlight-preview.html'),
      resolve: {
        broadcast: () => this.broadcast,
        highlightDetails: () => highlightDetails,
        showSave: () => showSave,
      },
      controller: HighlightPreviewController,
      controllerAs: 'vm',
      size: 'lg',
    });
  }

  openLowLatencyPreview() {
    this.preview = true;
  }

  onNewHighlightCaptured() {
    this.toaster.pop('success', 'Highlight saved');
    this.highlights = this.Highlight.query({ broadcastId: this.broadcast.id });
  }

  enterProducer() {
    window.location.replace(this.producerBroadcastURL);
  }

  startASAP() {
    let { Broadcast, ConfirmDialog } = this;

    let modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Start Now',
      actionButtonClass: 'success',
      headerText: 'Please Confirm',
      bodyText:
        'Are you ready to go live with your broadcast now? This will make your broadcast go live to viewers as soon as possible.',
    };

    ConfirmDialog.show(modalOptions).then(() => {
      const params = { starts_at: 'now' };
      if (!this.broadcast.source_broadcast_id) {
        // XXX: API will accidentally change the stops_at date because it is a function of
        // starts_at + duration (in minutes). So we need to remind it to keep it the same.
        params.stops_at = this.broadcast.stops_at;
      }
      Broadcast.update(
        { id: this.broadcast.id },
        params,
        (b) => this.reload(),
        (e) => {
          console.error(e);
          alert('Error starting broadcast. Please reload this page and try again.');
        }
      );
    });
  }

  stop() {
    let { Broadcast, ConfirmDialog } = this;

    let modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Stop Broadcast',
      actionButtonClass: 'danger',
      headerText: 'Please Confirm',
      bodyText: 'Are you sure you want to stop this broadcast?',
    };

    ConfirmDialog.show(modalOptions).then(() => {
      Broadcast.update(
        { id: this.broadcast.id },
        { stops_at: 'now' },
        () => {
          this.reload();
          if (this.activeTab == 'captions') {
            this.changeTab('');
          }
        },
        () => alert('Error stopping broadcast. Please reload this page and try again.')
      );
    });
  }

  generateEmailLink() {
    let startDateTime = moment(this.broadcast.starts_at).format('dddd, MMMM Do [at] h:mma');
    let subject = escape(`Invitation to ${this.broadcast.name}`);
    let body = escape(
      `Broadcast: ${this.broadcast.name}\n` +
        `Date: ${startDateTime}\n` +
        `\n` +
        `${this.broadcast.description}\n` +
        `\n` +
        `To view this event just click the link below:\n` +
        `${this.broadcast.viewer_url}\n` +
        `\n` +
        `If the above URL does not work try copying and pasting it into your browser.\n`
    );
    this.emailLink = `mailto:?subject=${subject}&body=${body}`;
  }

  embed() {
    const { $uibModal } = this;

    $uibModal.open({
      template: require('./modal-embed.html'),
      size: 'lg',
      controllerAs: 'vm',
      controller: EmbedSingleEventController,
      resolve: {
        broadcast: () => this.broadcast,
      },
    });
  }

  tweet() {
    let url = escape(this.broadcast.viewer_url);
    let text = escape(`Watch ${this.broadcast.name} online at`);
    window.open(
      'http://twitter.com/share?url=' + url + '&text=' + text,
      'Promote on Twitter',
      'dependent=1,height=400,width=600,resizable=1'
    );
  }

  facebook() {
    // Use the graph API directly since we don't have proper opengraph
    // headers on our show page.
    // https://developers.facebook.com/docs/graph-api/reference/v2.4/post
    let previewImg = this.broadcast.preview;
    if (!previewImg) {
      previewImg = `${IMG_ROOT}boxcast_social_play_square.png`;
    }

    // Use the "share" dialog (rather than "feed") so we can post into groups as well.
    // NOTE: the FB docs suggest that some of these params only work for "feed" but
    // they seem to work for share as well, so we're running with it!
    FB.ui(
      {
        method: 'share',
        href: this.broadcast.viewer_url,
        name: this.broadcast.name,
        title: this.broadcast.name,
        description: this.broadcast.description,
        picture: ensureHttpOnProtocolRelativeUrl(previewImg),
        caption: 'BoxCast :: a smarter way to stream',
        type: 'video',
        display: 'popup',
      },
      function (response) {}
    );
  }

  ///
  /// BoxCaster Settings
  ///

  get videoInputStandard() {
    const d = this.streamDiagnostics || {};
    // If BoxCaster has locked in, return that.  Otherwise, base it on the Box's preference to use SDI before HDMI before Composite
    if (d.locked_input == 'SDI') {
      return d.last_sdi_standard;
    } else if (d.locked_input == 'HDMI') {
      return d.last_hdmi_standard;
    } else if (d.locked_input == 'Composite2') {
      return d.last_composite_standard;
    } else {
      return d.last_sdi_standard || d.last_hdmi_standard || d.last_composite_standard || '';
    }
  }

  get videoInputName() {
    const d = this.streamDiagnostics || {};
    // If BoxCaster has locked in, return that.  Otherwise, base it on the Box's preference to use SDI before HDMI before Composite
    if (d.locked_input == 'Composite2') {
      return 'RCA';
    } else if (d.locked_input) {
      return d.locked_input; //SDI or HDMI
    } else {
      return (
        (d.last_sdi_standard && 'SDI') ||
        (d.last_hdmi_standard && 'HDMI') ||
        (d.last_composite_standard && 'RCA') ||
        ''
      );
    }
  }

  get streamingProfileName() {
    var tp = (this.broadcast || {}).transcoder_profile || '';
    tp = tp.replace(/:.*/, '').replace('p60', 'p');
    if (tp == 'audio') {
      tp = 'Audio';
    }
    return tp;
  }

  get lockedInputMismatchWarning() {
    const d = this.streamDiagnostics || {};
    var locked = d.locked_standard;
    var current = this.videoInputStandard;
    if (!locked || !current || locked == current) {
      return false;
    }
    // Don't worry about framerate changes; only about resolution or interlaced/progressive
    function stripFramerate(r) {
      if (r.indexOf('i') >= 0) {
        return r.substring(0, r.indexOf('i') + 1);
      } else if (r.indexOf('p') >= 0) {
        return r.substring(0, r.indexOf('p') + 1);
      } else {
        return r;
      }
    }
    return stripFramerate(locked) != stripFramerate(current);
  }

  get streamingProfileMatchesVideoInput() {
    var is = this.videoInputStandard;
    var sp = this.streamingProfileName;
    if (!is || !sp) {
      return true; //don't bother warning if one of them doesn't exist yet
    }
    var inputRes = is.substring(0, is.indexOf('p')) || is.substring(0, is.indexOf('i')) || '';
    var transcodeRes = sp.substring(0, sp.indexOf('p')) || '';
    var hfr = (this.broadcast || {}).actual_high_frame_rate === true;
    // Check for same resolution
    if (inputRes != transcodeRes) {
      return false;
    }
    // Check for high framerate on p60/i60 input
    var framerate = is.match(/[0-9.]+$/);
    framerate = parseFloat(framerate && framerate[0], 10);
    var inputHighFramerate = framerate > 30 && !isNaN(framerate);
    if (inputHighFramerate && !hfr) {
      return false;
    }
    return true;
  }

  ///
  /// Static RTMP Settings
  ///

  get staticRTMPStatusLabel() {
    if (!this.staticRTMPDiagnostics || !this.staticRTMPDiagnostics.connected) {
      return 'unknown';
    }
    return 'connected';
  }

  get staticRTMPStatus() {
    var diagnostics = this.staticRTMPDiagnostics || {};
    if (diagnostics.broadcasting) {
      return 'Broadcasting';
    } else if (diagnostics.connected) {
      return 'Connected';
    } else if (diagnostics.connected === false) {
      return 'Offline';
    } else {
      return '';
    }
  }

  get staticRTMPVideoInput() {
    if (!this.staticRTMPDiagnostics || !this.staticRTMPDiagnostics.connected) {
      return '';
    }
    const height = this.staticRTMPDiagnostics.video_height;
    const width = this.staticRTMPDiagnostics.video_width;
    const frameRate = this.staticRTMPDiagnostics.frame_rate;
    if (height == 0 || width == 0 || frameRate == 0) {
      return '';
    }
    return width + 'x' + height + ', ' + frameRate + ' FPS';
  }

  ///
  /// Viewer Chat
  ///

  get showChat() {
    // A broadcast content_settings override always takes precedence
    if (this.showChatHasBroadcastOverride) {
      return this.broadcast.content_settings.showChat;
    }
    return this.account.content_settings.showChat;
  }

  get showChatHasBroadcastOverride() {
    return this.broadcast.content_settings.showChat !== undefined;
  }

  updateShowChat() {
    const { Broadcast, toaster } = this;
    Broadcast.get({ id: this.broadcast.id }, (b) => {
      const cs = { ...b.content_settings, showChat: this.showChatStateValue };
      Broadcast.update(
        { id: this.broadcast.id },
        { content_settings: cs },
        (b) => {
          this.setBroadcast(b);
          toaster.pop('success', this.showChatStateValue ? 'Enabled chat' : 'Disabled chat');
        },
        (e) => {
          console.error(e);
          toaster.pop(
            'warning',
            `Unable to ${
              this.showChatStateValue ? 'enable' : 'disable'
            } chat. Please refresh the page and try again.`
          );
          this.reloadSilent();
        }
      );
    });
  }

  ///
  /// Live captions
  ///

  get enableCaptions() {
    // If there's a value specified in the broadcast metadata, use it.
    let captionsConfiguration = this.broadcast.metadata.live_captions || {};
    if (captionsConfiguration.enabled !== undefined) {
      return captionsConfiguration.enabled;
    }

    // If there's nothing specified in the metadata, assume it's enabled.
    return true;
  }

  updateEnableCaptions() {
    const { Broadcast, toaster } = this;
    Broadcast.get({ id: this.broadcast.id }, (b) => {
      const md = { ...b.metadata, live_captions: { enabled: this.enableCaptionsStateValue } };
      Broadcast.update(
        { id: this.broadcast.id },
        { metadata: md },
        (b2) => {
          this.setBroadcast(b2);
          toaster.pop(
            'success',
            this.enableCaptionsStateValue ? 'Enabled live captions' : 'Disabled live captions'
          );
        },
        (e) => {
          console.error(e);
          toaster.pop(
            'warning',
            `Unable to ${
              this.enableCaptionsStateValue ? 'enable' : 'disable'
            } live captions. Please refresh the page and try again.`
          );
          this.reloadSilent();
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./app/pages/events/detail.js